import { useContext, useEffect, useRef, useState } from "react";
import logo from "../../../../assets/logo.png";
import * as THREE from "three";
import { RoomEnvironment } from "three/addons/environments/RoomEnvironment.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader"; // Import RGBELoader
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { HomeContext } from "../../Context/HomeContext";
import { normalize } from "three/src/math/MathUtils";
import Chat from "../Chat/Chat";

export default function CanvasPart() {
  const canvasRef = useRef();
  const modelRef = useRef([]);
  const sceneRef = useRef();
  const cameraRef = useRef();
  const orbitRef = useRef();
  const rendererRef = useRef();
  const currentDesign = useRef({
    type: null, // 'text', 'image', 'clipart'
    data: null
  });

  const firstLoad = useRef(true);
  const [loadModel, setLoadModel] = useState(false);
  const loadModelRef = useRef(false);
  const [activeDesign, setActiveDesign] = useState(null);

  let newBaseColorTexture;
  let newNormalMapTexture, newNormalMapBaseRose;
  let newHeightMapTexture;
  let newRoughnessMapTexture;

  const zoomStep = 0.2;
  const minZoomDistance = 0.1;
  const maxZoomDistance = 30;

  // مرحله 1: تعریف تنظیمات اولیه دوربین برای هر مدل
  const cameraSettings = useRef({



    "Petal": {
      position: [0.0042423056368384015, 0.2153789521319734, -0.0006635994759279948],
      quaternion: [-0.5193737382303891, 0.4792758915517119, 0.473622328274502, 0.5255734296687217],
      rotation: [-1.5697051707838725, 0.011815624796104672, 1.4787067823388043]
    },
    "Rose": {
      position: [0.1044221536462562, 0.01564916545977032, -0.010601326872091848],
      quaternion: [-0.04866862477672107, 0.7393217403016337, 0.053749312695419396, 0.6694368832567239],
      rotation: [-2.1659715421449786, 1.3952236677155059, 2.173184510791283]
    },

    "Box": {
      position: [0.2510883948455773, 0.11289193668447348, 0.10086413017402018],
      quaternion: [-0.08892645688973977, 0.5490580418706096, 0.05890076372047377, 0.8289499695128737],
      rotation: [-0.5077053529961183, 1.1193283697753256, 0.46413384613170433]
    }


  });


  const {
    dataClient,
    rose,
    textDesign,
    loadingMain,
    setLoadingMain,
    material,
    quantity,
    boxSelected,
    croppedImage,
    cliPart,
    activeTab,
    activeSection, // 1: Rose  2: Design  3: Packaging
    prevActiveSection,
    setCost,
    setAddToCard,
    addToCard,
    sizeImage,
    flagScroll,
    setFlagScroll,
    imagesPreloaded
  } = useContext(HomeContext);

  const takeScreenShot = () => {
    const imgData = rendererRef.current.domElement.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = imgData;
    link.download = 'screenshot.jpg';
    // link.click();
    return imgData

  }
  useEffect(() => {
    if (loadModel) {
      console.log('addToCard', addToCard)

      if (addToCard) {
        //Screenshot
        const imageData = takeScreenShot()
        console.log('imgData base64', imageData)

        //Imagefile on rose
        console.log("current Design>>", currentDesign.current);


        //Form Data 



        setAddToCard(false)
      }
    }


  }, [addToCard])

  const resetCamera = () => {

    let type = null;

    if (rose?.roseType === "Petal") type = "Petal";
    else if (rose?.roseType === "Short-Stem-Rose") type = "Rose";
    if (activeSection === 3) type = "Box";

    if (type && cameraSettings.current[type]) {
      const { position, quaternion, rotation } = cameraSettings.current[type];

      cameraRef.current.position.set(...position);
      cameraRef.current.quaternion.set(...quaternion);
      cameraRef.current.rotation.set(...rotation, "XYZ"); // توجه: rotation.set فقط ۳ پارامتر می‌گیرد، "XYZ" ممکن است نادیده گرفته شود
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      resetCamera();
    }, 5000);
    return () => clearInterval(interval);
  }, [rose?.roseType, activeSection]);


  useEffect(() => {


    if (loadModel) {
      clearMeshContent();
      console.log('activeTab', activeTab)
      switch (activeTab) {
        case "AddText":
          loadText(textDesign?.text);
          break;
        case "AddImage":
          if (croppedImage) {
            loadImageInRectangle(croppedImage, {
              x: 300, // X position of the image on the canvas
              y: 290, // Y position of the image on the canvas
              width: 450, // Width of the image
              height: 450, // Height of the image
            });

          }

          break;
        case "AddClipart":
          if (cliPart) {
            loadImageInRectangle(cliPart.file, {
              x: 100, // X position of the image on the canvas
              y: 100, // Y position of the image on the canvas
              width: 800, // Width of the image
              height: 800, // Height of the image
            });
            currentDesign.current.type = 'clipart';
            currentDesign.current.data = {
              file: cliPart.file,
              id: cliPart.id // اگه داری
            };
          }

          break;

        default:
          break;
      }
    }
  }, [activeTab]);

  const updateModel = async () => {

    let modelUrl = null;

    console.log('updateModel activeSection', activeSection)
    console.log('updateModel prevActiveSection', prevActiveSection)
    switch (activeSection) {
      case 1:
        if (prevActiveSection === 2) modelUrl = null
      case 2:
        if (prevActiveSection === 1) {
          modelUrl = null
        }
        if (prevActiveSection === 3) {
          if (rose?.roseType === "Petal") {
            modelUrl = dataClient?.design.typeRose[1].modelurl;

            cameraRef.current.position.set(
              0.0042423056368384015, 0.2153789521319734, -0.0006635994759279948
            );
            cameraRef.current.quaternion.set(
              -0.5193737382303891, 0.4792758915517119, 0.473622328274502, 0.5255734296687217
            );
            cameraRef.current.rotation.set(
              -1.5697051707838725, 0.011815624796104672, 1.4787067823388043,
              "XYZ"
            );
          }

          if (rose?.roseType === "Short-Stem-Rose")
            modelUrl = dataClient?.design.typeRose[0].modelurl;

        }


        break;
      case 3:
        if (typeof boxSelected === "object") {
          if (material.title === "acrylic") {
            modelUrl = boxSelected.modelUrl;

            cameraRef.current.position.set(
              0.2510883948455773, 0.11289193668447348, 0.10086413017402018
            );

            cameraRef.current.quaternion.set(
              -0.08892645688973977, 0.5490580418706096, 0.05890076372047377, 0.8289499695128737
            );

            cameraRef.current.rotation.set(
              -0.5077053529961183, 1.1193283697753256, 0.46413384613170433,
              "XYZ"
            );

            const loaderhdr = new RGBELoader();
            loaderhdr.load(dataClient?.lightSetting.hdriFile2, (texture) => {
              texture.mapping = THREE.EquirectangularReflectionMapping;
              sceneRef.current.environment = texture;
              sceneRef.current.environmentIntensity =
                dataClient?.lightSetting.environmentIntensity2;
            });
          } else if (material.title === "Paper") {
            modelUrl = boxSelected.modelUrl;
            const loaderhdr = new RGBELoader();
            loaderhdr.load(dataClient?.lightSetting.hdriFile1, (texture) => {
              texture.mapping = THREE.EquirectangularReflectionMapping;
              sceneRef.current.environment = texture;
              sceneRef.current.environmentIntensity =
                dataClient?.lightSetting.environmentIntensity1;
            });
          }
        } else {
          console.log("no box selected yet");
          modelUrl = dataClient?.design.typeRose[0].modelurl;
        }
        break;
      default:
        break;
    }

    console.log('updateModel modelUrl', modelUrl)

    if (modelUrl) {
      setFlagScroll(false);
      await clearGLBModel(); // منتظر حذف کامل مدل قبلی بمانید
      await loadGLBfile(modelUrl, 0); // مدل جدید رو لود کن


    }
  };

  const updateDesign = async (modelUrl) => {
    await loadGLBfile(modelUrl, 0);
  };

  useEffect(() => {
    console.log('activeSection', activeSection)

    if (firstLoad.current === false) {
      if (loadModel) updateModel();
    }
  }, [activeSection]);

  const [mainSizeImage, setMainSizeImage] = useState(250);

  useEffect(() => {
    if (firstLoad.current === false) {
      const rectWidth = mainSizeImage + sizeImage * 100;
      const rectHeight = mainSizeImage + sizeImage * 100;

      // محاسبه مرکز canvas (1024x1024)
      const centerX = (1024 - rectWidth) / 2;
      const centerY = (1024 - rectHeight) / 2;

      const rectangleConfig = {
        x: centerX, // مرکز افقی
        y: centerY, // مرکز عمودی
        width: rectWidth,
        height: rectHeight,
      };

      if (loadModel) loadImageInRectangle(croppedImage, rectangleConfig);

    }
  }, [sizeImage]);

  let mainOption;



  window.addEventListener("keydown", (e) => {
    if (e.key === "l") {
      // Press 'L' to log the camera's state
      console.log("Camera Position:", cameraRef.current.position.toArray());
      console.log("Camera Quaternion:", cameraRef.current.quaternion.toArray());
      console.log(
        "Camera Rotation (Euler):",
        cameraRef.current.rotation.toArray()
      );
    }
  });



  function getFlippedCanvasImage(originalCanvas) {
    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');

    tempCanvas.width = originalCanvas.width;
    tempCanvas.height = originalCanvas.height;

    ctx.translate(0, tempCanvas.height);
    ctx.scale(1, -1); // برعکسش کنیم

    ctx.drawImage(originalCanvas, 0, 0);

    return tempCanvas.toDataURL('image/png');
  }


  const loadText = (mainText) => {


    const lines = [
      mainText.line1,
      mainText.line2,
      mainText.line3,
      mainText.line4,
    ];
    const petalMesh = modelRef.current.getObjectByName("print_zone_");

    const petalMeshes = [];

    modelRef.current.traverse((child) => {
      if (
        child instanceof THREE.Mesh &&
        child.name.toLowerCase().includes("print_zone")
      ) {
        petalMeshes.push(child); // Add matching meshes to an array
      }
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = 1024;
    canvas.height = 1024;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.translate(0, canvas.height); // انتقال نقطه شروع به پایین Canvas
    ctx.scale(1, -1); // وارونگی محور Y (بدون آینه‌ای کردن)

    let lineHeight = 80; // Adjust as needed

    const calculateFontSize = (text) => {
      if (text.length <= 5) {
        lineHeight = 120;
        return 130;
      } // Default size for short text
      if (text.length <= 10) {
        lineHeight = 100;

        return 100;
      } // Medium text
      if (text.length <= 15) {
        lineHeight = 70;

        return 80;
      }
      return 80; // Extra long text
    };

    ctx.fillStyle = textDesign?.selectedTextColor.hex || "black"; // Use default color if not selected

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.direction = "rtl";


    const totalHeight = lines.filter(Boolean).length * lineHeight; // Total height of the text block
    const startY = (canvas.height - totalHeight) / 2 + lineHeight / 2;

    const fontSize = calculateFontSize(lines[0]);

    lines.forEach((line, index) => {
      if (line) {
        // const fontSize = calculateFontSize(line);
        ctx.font = `${fontSize}px ${textDesign?.fontFamily || "Arial"}`;
        ctx.fillStyle = textDesign?.selectedTextColor.hex || "black";
        ctx.fillText(line, canvas.width / 2, startY + index * lineHeight);
      }
    });

    const texture = new THREE.CanvasTexture(canvas);

    const imageURL = getFlippedCanvasImage(canvas);
    const link = document.createElement('a');
    link.href = imageURL;
    link.download = 'design.png';
    // link.click();

    currentDesign.current.type = 'text';
    currentDesign.current.data = {
      ...textDesign
    };
    currentDesign.current.snapshot = imageURL;

    texture.needsUpdate = true;

    if (petalMesh) {
      if (petalMesh.material.map) {
        petalMesh.material.map.dispose();
      }
      petalMesh.material.map = null;

      petalMesh.material = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
      });

      petalMesh.material.needsUpdate = true;
    } else if (petalMeshes.length > 0) {
      petalMeshes.forEach((petalMesh) => {
        // Remove the previous texture if exists
        if (petalMesh.material.map) {
          petalMesh.material.map.dispose();
          petalMesh.material.map = null;
        }

        // Apply the new texture
        petalMesh.material.map = null;
        petalMesh.material = new THREE.MeshBasicMaterial({
          map: texture,
          transparent: true,
        });

        petalMesh.material.needsUpdate = true;
      });
    }

  };

  function updateMeshBaseColorTexture(
    baseColorTexturePath,
    colorCode,
    baseColorCode
  ) {


    modelRef.current.traverse((child) => {
      // if (child.isMesh && targetMeshes.includes(child.name)) {
      if (child.isMesh) {
        const material = child.material;

        if (material) {
          let color;
          if (
            child.name.toLowerCase().includes("petal") &&
            !child.name.includes("print_zone")
          ) {
            color = colorCode.startsWith("#") ? colorCode : "#" + colorCode;
            // material.color.set(color);
            child.material.color.set(new THREE.Color(color));
          }
          if (child.name.toLowerCase().includes("base")) {
            const color1 = baseColorCode.startsWith("#")
              ? baseColorCode
              : "#" + baseColorCode;
            // material.color.set(color1);
            child.material.color.set(new THREE.Color(color1));

          }
          child.material.needsUpdate = true;

        }
      }
    });

    // 3. بارگذاری تکسچرها پس از اعمال رنگ اولیه
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load(baseColorTexturePath, (texture) => {
      texture.flipY = false;
      texture.colorSpace = THREE.SRGBColorSpace;
      modelRef.current.traverse((child) => {
        if (child.isMesh && child.material) {
          // 4. فقط برای قسمت‌های مورد نظر تکسچر را اعمال کنید
          if (child.name.toLowerCase().includes("petal")) {
            child.material.map = texture;
            child.material.normalMap = newNormalMapTexture;
            child.material.roughnessMap = newRoughnessMapTexture;
            child.material.needsUpdate = true;
          }
          if (child.name.toLowerCase().includes("base")) {
            child.material.normalMap = newNormalMapBaseRose;
          }
        }
      });
    }, undefined, (error) => {
      console.error("Error loading texture:", error);
    });



  }

  const init = () => {
    setLoadingMain(true);
    // Create scene

    const textureLoader = new THREE.TextureLoader();

    // Load your textures (update paths to your textures)
    newBaseColorTexture = textureLoader.load(
      "/textures/colors textures/red_02_E22202.png"
    );
    newNormalMapBaseRose = textureLoader.load(
      "/textures/principal textures/normal_base rosa.png"
    );
    newNormalMapTexture = textureLoader.load(
      "/textures/principal textures/Petal_Rose_Red_Normal.png"
    );
    newRoughnessMapTexture = textureLoader.load(
      "/textures/principal textures/rose_roughness.png"
    );

    const scene = new THREE.Scene();
    // scene.background = new THREE.Color(0xf0f0f0);
    sceneRef.current = scene;

    // Set up camera
    const camera = new THREE.PerspectiveCamera(
      45,
      canvasRef.current.clientWidth / canvasRef.current.clientHeight,
      0.01,
      1000
    );

    camera.position.set(
      0.31817526080789105,
      0.039400304623192675,
      -0.02908931569126374
    );

    camera.quaternion.set(
      -0.04133254261349739,
      0.7372057012213301,
      0.04528377071470179,
      0.6728809368066008
    );

    camera.rotation.set(
      -2.206768450613856,
      1.418069687034873,
      2.2123726704585045
    );

    camera.lookAt(0, 0, 0);
    cameraRef.current = camera;

    // Set up renderer
    const renderer = new THREE.WebGLRenderer({ preserveDrawingBuffer: true, antialias: true, alpha: true });
    renderer.setClearColor(0x000000, 0); // Make the background transparent
    renderer.setSize(
      canvasRef.current.clientWidth,
      canvasRef.current.clientHeight
    );

    // renderer.toneMapping = THREE.ACESFilmicToneMapping;
    // renderer.toneMapping = THREE.NeutralToneMapping;
    renderer.toneMapping = THREE.LinearToneMapping;
    renderer.toneMappingExposure = 1;

    rendererRef.current = renderer;
    canvasRef.current.appendChild(renderer.domElement);

    // Set up OrbitControls
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.enablePan = false;

    // controls.autoRotate = true
    controls.maxPolarAngle = Math.PI / 2;
    controls.dampingFactor = 0.05;
    controls.enableZoom = true;
    controls.minDistance = 0.065;
    controls.maxDistance = 0.5;
    orbitRef.current = controls;

    const loaderhdr = new RGBELoader();

    loaderhdr.load(dataClient?.lightSetting.hdriFile2, function (texture) {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      sceneRef.current.environment = texture; // Set the environment for the scene
      sceneRef.current.environmentIntensity =
        dataClient?.lightSetting.environmentIntensity2; // Set the environment for the scene
    });

    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.68);
    // directionalLight.castShadow = true;
    directionalLight.position.set(0, 10, 7);
    // sceneRef.current.add(directionalLight);

    // Lighting
    const light = new THREE.DirectionalLight(0xffffff, 1);
    light.position.set(5, 5, 5);
    // sceneRef.current.add(light);

    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    // sceneRef.current.add(ambientLight);

    // Animate function
    const animate = () => {
      requestAnimationFrame(animate);
      orbitRef.current.update();
      rendererRef.current.render(sceneRef.current, cameraRef.current);
    };
    animate();

    // Handle window resize
    const handleResize = () => {
      cameraRef.current.aspect =
        canvasRef.current.clientWidth / canvasRef.current.clientHeight;
      cameraRef.current.updateProjectionMatrix();
      rendererRef.current.setSize(
        canvasRef.current.clientWidth,
        canvasRef.current.clientHeight
      );
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (rendererRef.current) rendererRef.current.dispose();
    };
  };

  function clearGLBModel() {
    setLoadingMain(true);
    return new Promise((resolve) => {
      sceneRef.current.traverse((object) => {
        if (object.isMesh) {
          if (object.geometry) object.geometry.dispose();
          if (object.material) {
            if (Array.isArray(object.material)) {
              object.material.forEach((material) => disposeMaterial(material));
            } else {
              disposeMaterial(object.material);
            }
          }
        }
      });

      while (sceneRef.current.children.length > 0) {
        const child = sceneRef.current.children[0];
        sceneRef.current.remove(child);
      }

      requestAnimationFrame(resolve); // حل مشکل همزمانی با استفاده از `requestAnimationFrame`
      setLoadingMain(false);
    });
  }

  function loadGLBfile(url, n) {
    setLoadingMain(true);

    console.log('loadGLBfile>>>', url)
    const loader = new GLTFLoader();
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.6/');
    loader.setDRACOLoader(dracoLoader);
    // Load the GLB file
    loader.load(
      url,
      (gltf) => {
        modelRef.current = gltf.scene;
        sceneRef.current.add(gltf.scene);


        if (rose?.roseType !== "Petal")
          fitToView(modelRef.current, cameraRef.current, orbitRef.current);

        if (material?.title === "acrylic") {
          gltf.scene.traverse((child) => {
            if (child.isMesh) {
              const mat = child.material;

              // بررسی اینکه نام مش یا متریال شامل 'Acrylic' باشه
              const name = (child.name || "") + (mat?.name || "");
              const isAcrylic = name.toLowerCase().includes("acrylic");

              if (isAcrylic && mat) {
                mat.envMapIntensity = 0.1; // کاهش بازتاب
                mat.roughness = 0.5; // کمی مات کردن
                mat.metalness = 0.0;  // اطمینان از غیر فلزی بودن
                mat.transparent = true;
                mat.opacity = 0.15; // یا حتی 1 اگر اصلاً شفاف نباشه
                mat.needsUpdate = true;


              }

              child.castShadow = true;
              child.receiveShadow = true;
            }
          });



        }


        setLoadModel(true);
        loadModelRef.current = true

        if (rose?.roseColor) {
          updateMeshBaseColorTexture(
            rose?.roseColor.texture,
            rose?.roseColor.hex,
            rose?.roseColor.hexbase
          );
        }


        clearMeshContent();
        if (activeTab === "AddText") {
          loadText(textDesign?.text);
        }
        if (activeTab === "AddImage") {
          loadImageInRectangle(croppedImage, {
            x: 300, // X position of the image on the canvas
            y: 290, // Y position of the image on the canvas
            width: 450, // Width of the image
            height: 450, // Height of the image
          });
        }
        if (activeTab === "AddClipart") {
          loadImageInRectangle(cliPart.file, {
            x: 100, // X position of the image on the canvas
            y: 100, // Y position of the image on the canvas
            width: 800, // Width of the image
            height: 800, // Height of the image
          });
        }




        if (n === 3) {
          const glassMaterial = new THREE.MeshPhysicalMaterial({
            color: 0xffffff, // Base color
            roughness: 0, // No roughness for clear glass
            transmission: 1, // Enables transparency (1 = fully transparent)
            thickness: 0.001, // Physical thickness of the object
            ior: 1.3, // Index of Refraction (glass = ~1.5)
            specularIntensity: 1, // Specular highlights
            specularColor: 0xffffff, // Color of specular highlights
            envMapIntensity: 0.8, // Intensity of reflections
            metalness: 0, // Non-metallic material
            clearcoat: 1, // Add clearcoat for shine
            clearcoatRoughness: 0, // Keep clearcoat smooth
          });

          // sceneRef.current.traverse((object) => {
          //   if (object.isMesh && object.name.includes("Acrylic")) {
          //     object.material = glassMaterial; // Assign the material
          //   }
          // });
        }
        setLoadingMain(false);
        setFlagScroll(true);
      },
      (xhr) => {
        // Optionally, you can monitor loading progress here
        // console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        setLoadingMain(true);
      },
      (error) => {
        console.error("An error happened", error);
      }
    );
  }

  function disposeMaterial(material) {
    // Dispose of textures
    for (const key in material) {
      if (material[key] && material[key].isTexture) {
        material[key].dispose();
      }
    }
    material.dispose();
  }

  const loadImageInRectangle = (imagePath, rectangleConfig) => {

    const targetMesh = modelRef.current.getObjectByName("print_zone_");
    if (!targetMesh) {
      console.log("Target mesh 'print_zone' not found!");
    }

    const loader = new THREE.TextureLoader();
    loader.load(
      imagePath,
      (texture) => {
        // Create image element to get original dimensions
        const img = new Image();
        img.src = imagePath;

        img.onload = () => {

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set canvas size (power of 2 for better texture mapping)
          canvas.width = 1024;
          canvas.height = 1024;

          ctx.clearRect(0, 0, canvas.width, canvas.height);

          // Calculate aspect ratios
          const imgAspect = img.width / img.height;

          const canvasAspect = canvas.width / canvas.height;

          // Calculate dimensions to fit image while preserving aspect ratio
          let drawWidth, drawHeight, offsetX, offsetY;

          if (imgAspect > canvasAspect) {
            // Image is wider than canvas (fit to width)
            drawWidth = canvas.width;
            drawHeight = drawWidth / imgAspect;
            offsetX = 0;
            offsetY = (canvas.height - drawHeight) / 2;
          } else {
            // Image is taller than canvas (fit to height)
            drawHeight = canvas.height;
            drawWidth = drawHeight * imgAspect;
            offsetY = 0;
            offsetX = (canvas.width - drawWidth) / 2;
          }

          // Apply rectangle config if provided
          if (rectangleConfig) {
            const { x, y, width, height } = rectangleConfig;
            const scaleFactor = 1.1;

            const newDrawWidth = drawWidth * scaleFactor;
            const newDrawHeight = drawHeight * scaleFactor;
            
            // محاسبه offset جدید برای قرارگیری وسط مستطیل
            const newOffsetX = (canvas.width - newDrawWidth) / 2;
            const newOffsetY = (canvas.height - newDrawHeight) / 2;

            // Calculate scaling factors
            const scaleX = width / canvas.width;
            const scaleY = height / canvas.height;

            // Save context, apply transformations, and draw image
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(scaleX, scaleY);
            ctx.drawImage(img, newOffsetX, newOffsetY, newDrawWidth, newDrawHeight);
            ctx.restore();
          } else {
            // Draw image centered if no rectangle config is provided
            // ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const scaleFactor = 1.1;
            const newDrawWidth = drawWidth * scaleFactor;
            const newDrawHeight = drawHeight * scaleFactor;
            const newOffsetX = (canvas.width - newDrawWidth) / 2;
            const newOffsetY = (canvas.height - newDrawHeight) / 2;
            
            ctx.drawImage(img, newOffsetX, newOffsetY, newDrawWidth, newDrawHeight);
            

          }

          // Create texture from canvas
          const finalTexture = new THREE.CanvasTexture(canvas);
          finalTexture.flipY = false; // Depending on your UV mapping
          finalTexture.colorSpace = THREE.SRGBColorSpace;

          // Apply texture to mesh
          if (targetMesh) {
            if (targetMesh.material.map) {
              targetMesh.material.map.dispose();
            }

            targetMesh.material = new THREE.MeshBasicMaterial({
              map: finalTexture,
              transparent: true
            });
            targetMesh.material.needsUpdate = true;
          } else {
            const petalMeshes = [];
            modelRef.current.traverse((child) => {
              if (
                child instanceof THREE.Mesh &&
                child.name.toLowerCase().includes("print_zone")
              ) {
                petalMeshes.push(child); // Add matching meshes to an array
              }
            });

            petalMeshes.forEach((petalMesh) => {
              // Remove the previous texture if exists
              if (petalMesh.material.map) {
                petalMesh.material.map.dispose();
                petalMesh.material.map = null;
              }

              // Apply the new texture
              petalMesh.material.map = null;

              const material = new THREE.MeshStandardMaterial({
                map: finalTexture, // Use canvas texture for material
                transparent: true, // Make the material transparent
                opacity: 1.0, // Full opacity for the image
              });

              // Assign the material to the target mesh
              petalMesh.material = material;
              petalMesh.material.needsUpdate = true;
            });
          }
          // Optional: Save the design
          currentDesign.current.type = 'image';
          currentDesign.current.data = { imagePath };
          currentDesign.current.snapshot = canvas.toDataURL();
        };

        img.onerror = () => {
          console.error("Failed to load image:", imagePath);
        };
      },
      undefined,
      (error) => {
        console.error("Error loading texture:", error);
      }
    );
  };


  const fitToView = (model, camera, controls) => {
    const box = new THREE.Box3().setFromObject(model); // Get model bounds
    const center = box.getCenter(new THREE.Vector3()); // Get center point
    const size = box.getSize(new THREE.Vector3()); // Get size of the model

    const maxDim = Math.max(size.x, size.y, size.z);
    const fitHeightDistance =
      maxDim / (2 * Math.tan(THREE.MathUtils.degToRad(camera.fov) / 2));

    const fitWidthDistance = fitHeightDistance / camera.aspect;
    let distance = Math.max(fitHeightDistance, fitWidthDistance);

    distance *= 1.8; // Add some padding (increase this if needed)

    // Set camera position
    const direction = new THREE.Vector3()
      .subVectors(camera.position, center)
      .normalize();
    camera.position.copy(direction.multiplyScalar(distance).add(center));
    camera.lookAt(center);

    // Update controls target
    controls.target.copy(center);
    controls.update();
  };

  const clearMeshContent = () => {

    console.log('parisa clearMeshContent')

    const targetMesh = modelRef.current.getObjectByName("print_zone_");
    const petalMeshes = [];
    if (!targetMesh) {

      modelRef.current.traverse((child) => {
        if (
          child instanceof THREE.Mesh &&
          child.name.toLowerCase().includes("print_zone")
        ) {
          petalMeshes.push(child); // Add matching meshes to an array
        }
      });
    }




    if (targetMesh && targetMesh.material) {
      // Dispose of the current material and texture
      if (targetMesh.material.map) {
        targetMesh.material.map.dispose();
        targetMesh.material.map = null;
      }
      // Clear the material
      targetMesh.material.dispose();
      targetMesh.material = new THREE.MeshBasicMaterial({
        color: 0xffffff, // Default blank material (white)
        transparent: true,
        opacity: 0, // Make it fully invisible
      });
      targetMesh.material.needsUpdate = true;
    } else {
      petalMeshes.forEach((petalMesh) => {
        // Remove the previous texture if exists
        if (petalMesh.material.map) {
          petalMesh.material.map.dispose();
          petalMesh.material.map = null;
        }

        // Apply the new texture
        petalMesh.material.dispose();
        petalMesh.material.map = null;
        petalMesh.material = new THREE.MeshBasicMaterial({
          color: 0xffffff, // Default blank material (white)
          transparent: true,
          opacity: 0,
        });

        petalMesh.material.needsUpdate = true;
      });
    }
  };

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      init(); // Call init function to set up Three.js
    }
  }, []);

  useEffect(() => {
    if (loadModel) {
      loadText(textDesign.text);
    }
  }, [textDesign]);

  useEffect(() => {
    if (loadModel) {
      if (croppedImage) {
        loadImageInRectangle(croppedImage, {
          x: 300, // X position of the image on the canvas
          y: 290, // Y position of the image on the canvas
          width: 450, // Width of the image
          height: 450, // Height of the image
        });

        // ,{width:1000,height:1000}
      }
    }
  }, [croppedImage]);

  useEffect(() => {
    if (loadModel) {
      if (cliPart) {
        loadImageInRectangle(cliPart.file, {
          x: 100, // X position of the image on the canvas
          y: 100, // Y position of the image on the canvas
          width: 800, // Width of the image
          height: 800, // Height of the image
        });
      }
    }
  }, [cliPart]);

  useEffect(() => {
    if (firstLoad.current === false) {
      console.log('rose?.roseType', rose?.roseType)
      if (rose?.roseType === "Petal") {
        clearGLBModel();
        loadGLBfile(dataClient?.design.typeRose[1].modelurl, 0);

        cameraRef.current.position.set(
          0.0042423056368384015, 0.2153789521319734, -0.0006635994759279948
        );
        cameraRef.current.quaternion.set(
          -0.5193737382303891, 0.4792758915517119, 0.473622328274502, 0.5255734296687217
        );
        cameraRef.current.rotation.set(
          -1.5697051707838725, 0.011815624796104672, 1.4787067823388043,
          "XYZ"
        );


      } else if (rose?.roseType === "Short-Stem-Rose") {
        clearGLBModel();
        loadGLBfile(dataClient?.design.typeRose[0].modelurl, 0);

        cameraRef.current.position.set(
          0.31817526080789105,
          0.039400304623192675,
          -0.02908931569126374
        );
        cameraRef.current.quaternion.set(
          -0.04133254261349739,
          0.7372057012213301,
          0.04528377071470179,
          0.6728809368066008
        );
        cameraRef.current.rotation.set(
          -2.206768450613856,
          1.418069687034873,
          2.2123726704585045
        );
      }
    }
  }, [rose?.roseType]);

  useEffect(() => {
    if (firstLoad.current === false) {
      if (activeSection === 3) {
        let URL;
        if (typeof boxSelected === "object") {
          if (material.title === "acrylic") {
            clearGLBModel();
            URL = boxSelected.modelUrl;

            cameraRef.current.position.set(
              0.2510883948455773, 0.11289193668447348, 0.10086413017402018
            );

            cameraRef.current.quaternion.set(
              -0.08892645688973977, 0.5490580418706096, 0.05890076372047377, 0.8289499695128737
            );

            cameraRef.current.rotation.set(
              -0.5077053529961183, 1.1193283697753256, 0.46413384613170433,
              "XYZ"
            );

            const loaderhdr = new RGBELoader();

            loaderhdr.load(
              dataClient?.lightSetting.hdriFile2,
              function (texture) {
                texture.mapping = THREE.EquirectangularReflectionMapping;
                sceneRef.current.environment = texture; // Set the environment for the scene
                sceneRef.current.environmentIntensity =
                  dataClient?.lightSetting.environmentIntensity2; // Set the environment for the scene
              }
            );

            updateDesign(URL);

          } else if (material.title === "Paper") {
            clearGLBModel();
            URL = boxSelected.modelUrl;
            const loaderhdr = new RGBELoader();

            loaderhdr.load(
              dataClient?.lightSetting.hdriFile1,
              function (texture) {
                texture.mapping = THREE.EquirectangularReflectionMapping;
                sceneRef.current.environment = texture; // Set the environment for the scene
                sceneRef.current.environmentIntensity =
                  dataClient?.lightSetting.environmentIntensity1;
              }
            );

            updateDesign(URL);
          }
        } else {
          console.log("no box selected yet");
          clearGLBModel();
        }
      }
    }
  }, [boxSelected]);

  useEffect(() => {
    if (firstLoad.current === false && loadModel && rose?.roseColor) {
      console.log('imagesPreloaded', imagesPreloaded)
      console.log('rosecolor', rose?.roseColor)
      if (rose?.roseColor) {
        updateMeshBaseColorTexture(
          rose?.roseColor.texture,
          rose?.roseColor.hex,
          rose?.roseColor.hexbase
        );
      }
    }
  }, [rose?.roseColor]);

  const handleReset = () => {
    // fitToView(modelRef?.current, cameraRef.current, orbitRef.current);
    resetCamera();
    // cameraRef.current.position.set(
    //   -0.3518734965497957,
    //   0.23914218048842792,
    //   0.0804560829307368
    // );
  };


  const handleZoomIn = () => {

    const distance = cameraRef.current.position.distanceTo(orbitRef.current.target);
    const newDistance = distance * 0.8;

    cameraRef.current.position.lerpVectors(
      cameraRef.current.position,
      orbitRef.current.target,
      1 - newDistance / distance
    );

    orbitRef.current.update();


    // cameraRef.current.fov = Math.max(10, cameraRef.current.fov - 1); // Decrease FOV to zoom in
    // cameraRef.current.updateProjectionMatrix();
  };

  const handleZoomOut = () => {

    const distance = cameraRef.current.position.distanceTo(orbitRef.current.target);
    const newDistance = distance * 1.2;

    cameraRef.current.position.lerpVectors(
      cameraRef.current.position,
      orbitRef.current.target,
      1 - newDistance / distance
    );

    orbitRef.current.update();


    // cameraRef.current.fov = Math.min(100, cameraRef.current.fov + 1); // Increase FOV to zoom out
    // cameraRef.current.updateProjectionMatrix();
  };

  return (
    <>
      <div className="CanvasPart">

        <div className="Logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="Chat-min992">
          <Chat />
        </div>

        <div className="Canvas" ref={canvasRef}></div>

        <div className="CanvasPart-controler">
          <button className="CanvasPart-controler-item" onClick={handleReset}>
            <i
              className="bi bi-arrow-counterclockwise CanvasPart-controler-item-i"
              style={{
                transform: "rotate(.09turn)",
              }}
            ></i>
          </button>
          <button className="CanvasPart-controler-item" onClick={handleZoomOut}>
            <i className="bi bi-dash-lg CanvasPart-controler-item-i"></i>
          </button>
          <button className="CanvasPart-controler-item" onClick={handleZoomIn}>
            <i className="bi bi-plus-lg CanvasPart-controler-item-i"></i>
          </button>
        </div>
      </div>
    </>
  );
}
